import { fmt } from './LeadTimeline'
const C = { Delivered: ['#DFF5E5', '#28A745'], Failed: ['#FBE3E6', '#DC3545'], Pending: ['#FFF6D6', '#B58900'] }
/* Webhook delivery / status presentation */
export default function WebhookStatusTable({ rows }) {
  return (<div className="card"><div className="card-body table-responsive"><table className="table align-middle mb-0">
    <thead><tr><th>Event</th><th>Endpoint</th><th>Status</th><th>Attempts</th><th>HTTP</th><th>Time</th><th /></tr></thead>
    <tbody>{rows.map(w => <tr key={w.id}><td>{w.event}</td><td><small>{w.url}</small></td>
      <td><span className="badge-soft" style={{ background: C[w.status][0], color: C[w.status][1] }}>{w.status}</span></td>
      <td>{w.attempts}</td><td>{w.http ?? '—'}</td><td><small>{fmt(w.at)}</small></td>
      <td>{w.status === 'Failed' && <button className="btn btn-sm btn-outline-danger">Retry</button>}</td></tr>)}</tbody></table></div></div>)
}
